import React from 'react'
// libs
import styled from 'styled-components'
import { useSelector } from 'react-redux'
// themes
import { colors } from 'themes/index'
// static
import DoneIcon from '@mui/icons-material/CheckCircleOutlineRounded'
// store
import { publicFormSelector } from 'store/reducers/publicRisk'

const MessageWrapper = styled.div`
  font-size: 20px;
  text-align: center;
  color: ${colors.gray300};
  height: calc(100dvh - 104px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  svg {
    height: 160px;
    width: 160px;
    margin-bottom: 40px;

    path {
      fill: ${colors.purple400};
    }
  }
`

const SuccessMessage: React.FC = () => {
  const { successText } = useSelector(publicFormSelector)

  return (
    <MessageWrapper>
      <DoneIcon />
      <span>{successText}</span>
    </MessageWrapper>
  )
}

export default SuccessMessage
